import React from "react";
import { object, array, number, string, bool } from "prop-types";

import { Link } from "@quintype/components";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import StoryDate from "../../atoms/story-date";

import "./story-card26.m.css";

const StoryCard26 = ({ story, aspectRatio, imageType, headerType, headerLevel, lineClamp, bigCard = false }) => {
  const computedHeaderType = headerType || (bigCard ? 3 : 4);
  const computedHeaderLevel = headerLevel || (bigCard ? 3 : 4);
  const widths = bigCard ? [400, 700] : [400];

  return (
    <div className="story-card story-card-26" styleName="story-card-26" id="story-card-26">
      <Link href={`/${story.slug}`}>
        <CardImage
          story={story}
          showVideoIcon
          aspectRatio={aspectRatio}
          imageType={imageType}
          widths={widths}
          sizes="(max-width: 1024px) 20vw, 100vw"
        />
      </Link>
      <Link href={`/${story.slug}`} className="headline-link">
        <Headline
          text={story.headline}
          headerType={computedHeaderType}
          headerLevel={computedHeaderLevel}
          story={story}
          lineClamp={lineClamp}
        />
      </Link>
      <StoryDate story={story} />
    </div>
  );
};

StoryCard26.defaultProps = {
  aspectRatio: [5, 4],
  imageType: "image5x4",
  lineClamp: 2
};

StoryCard26.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number,
  lineClamp: number,
  bigCard: bool
};

export default StoryCard26;
